import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ActionBase } from 'store/ActionBase';
import { RedirectLoginData, saveGenerator } from 'store/connect/RedirectLoginData';

/**
 * リダイレクトログインからのリクエストを受け取るhook
 */
export const useRedirectLoginRequest = (dispatch: React.Dispatch<ActionBase>) => {
	const location = useLocation();
	const search = location.search;
	const queryParams = new URLSearchParams(search);

	/**
	 * こどもID登録から来た場合のパラメータ
	 * GETで飛んでくるのでReact上はURLデコードされた状態
	 */

	const client_id = queryParams.get('client_id');
	const redirect_uri = queryParams.get('redirect_uri');
	const isRedirectParamsOk = !!client_id;
	const redirectLoginData: RedirectLoginData = {
		client_id,
		redirect_uri,
	};
	useEffect(() => {
		if (isRedirectParamsOk) {
			saveGenerator(dispatch, redirectLoginData);
		}
	}, []);

	return {
		client_id: redirectLoginData.client_id,
		redirect_uri: redirectLoginData.redirect_uri,
	};
};
